import React, { useEffect, useRef } from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useState } from 'react';
import PageBanner from '../Components/Other/PageBanner'
import PersonalInformation from '../Components/MakeAppointment/PersonalInformation'
import Shedule from '../Components/MakeAppointment/Shedule'
import Payment from '../Components/MakeAppointment/Payment';
import PaymentSuccessful from '../Components/MakeAppointment/PaymentSuccessful'
import ProgressBar from '../Components/MakeAppointment/ProgressBar'
import { useDispatch } from 'react-redux';
import { CommonApiFun } from '../Redux/Action/index'
import { API_BASE_URL } from '../config'
import { ToastContainer, toast } from 'react-toastify';
import ToastMgs from '../Components/Other/ToastMgs'
import { useNavigate } from 'react-router-dom'
import { routes } from '../MainPage'
import OldPatient from '../Components/MakeAppointment/oldPatient'
import {useSelector} from 'react-redux'
// import svg from '../img/symbol.svg'

function MakeAppointmnet(props) {
    let navigate = useNavigate();
    const Branch = useSelector(state => state.clinicInfo);
    const dispatch = useDispatch()
    const myRef = useRef(null)
    const [state, setState] = useState({ FirstName: "", LastName: '', Description: '', Gender: 'Male', MobileNo: '', Email: '', Address: '', BirthDate: '', error: false, showDatePiker: false, day: '', time: "", activeTab: 1, isLoading: false, res: '', Endtime: '', razorpay_payment_id: '', userImage: '', ImageFile: '', paymentRes: "", appointmnetType: "new", fileId: '', Age: '', fileLoader: false, mainTab: 1,Options:{ show: false, value: '' },branchOption:{ show: false, value: Branch[0] } })
    const handleChange = (e, Name) => {
        setState((prev) => ({ ...prev, [Name]: e.target.value, error: false }))
    }
    useEffect(() => { executeScroll() }, [state.activeTab])
    const executeScroll = () => {

        //myRef.current.scrollIntoView();
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })

    }
    const handleFileChcek = (e) => {
        e.preventDefault();
        //  alert(state.fileId)
        var data = { file_number: (state.fileId).trim(), }

        if (state.fileId != "") {
            setState((prev) => ({ ...prev, fileLoader: true }))
            //toast(<ToastMgs status={res.status} message={'Patient data added successfully.'} />)
            dispatch(CommonApiFun("api/patient_history/post", JSON.stringify(data))).then(async (res) => {
                setState((prev) => ({ ...prev, fileLoader: false }))
              
                if (res.status == "success") {
                    var { appointment, patient, appointment_data, dieses } = res.data
                   
                    await dispatch({ type: "PATIENT_FILE_INFO", payload: { appointment, patient, fileId: (state.fileId).trim(), appointment_data, dieses } })
                    navigate(routes.AppointmentHistory + "/" + (state.fileId).trim(), { state: res, fileId: (state.fileId).trim() });
                } else {
                    //toast.error(res.message)
                    toast(<ToastMgs status={res.status} message={res.message} />)
                }
            }).catch((e) => {
                setState((prev) => ({ ...prev, fileLoader: false }))
                toast.error("Oops! ,something went wrong try again later...");
                
            }
            )
        } else {
            toast(<ToastMgs status={"fail"} message={'Please enter your File Id'} />)
        }
    }
    const handleSubmit = (data) => {
        setState((prev) => ({ ...prev, isLoading: true, }))
       
        var fdata = new FormData();
        fdata.append("address", state.Address)
        fdata.append("age", state.Age)
        fdata.append("description", state.Description)
        fdata.append("email", state.Email)
        fdata.append("first_name", state.FirstName)
        fdata.append("last_name", state.LastName)
        fdata.append("mobile", state.MobileNo)
        fdata.append("profile_image", state.ImageFile)
        fdata.append("birthdate", state.BirthDate)
        fdata.append("gender", state.Gender)
        fdata.append("blood_group", state.Options.value)
      
        fdata.append("patient_id", state.res != "" ? state.res.patient_key : "")
    
        fdata.append("old_image", state.res !== "" ? state.res.patient_data.profile_image : '')

        dispatch(CommonApiFun("api/appointment/post", fdata)).then((res) => {
            if (res.status == "success") {
                if (state.res != "") {
                    toast(<ToastMgs status={res.status} message={'Patient data updated successfully.'} />)
                } else {
                    toast(<ToastMgs status={res.status} message={'Patient data added successfully.'} />)
                }

                setState((prev) => ({ ...prev, isLoading: false, activeTab: 2, res }))
            } else {
                toast(<ToastMgs status={res.status} message={res.message} />)
                setState((prev) => ({ ...prev, isLoading: false, }))
            }
        }).catch((e) => { toast.error("Oops! ,something went wrong try again later..."); setState((prev) => ({ ...prev, isLoading: false, })) })


    }
    return (
        <PageWrapper className={"index-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper" ref={myRef} >
                    <PageBanner pageName={"Make Appointment"} ></PageBanner>
                    <div className="MainContent"  >
                        <div className="container">
                            <ul className="appint-tabs">
                                <li className={`appint-tab-link  ${state.mainTab == 1 ? 'appint-tab-current' : 'show-apoint'}`} data-tab="tab-1" onClick={() => setState((prev) => ({ ...prev, mainTab: 1 }))}>
                                    New Patient 
                                </li>
                                <li className={`appint-tab-link  ${state.mainTab == 2 ? 'appint-tab-current' : 'show-apoint'}`} data-tab="tab-2"
                                    onClick={() => {
                                        setState((prev) => ({ ...prev, mainTab: 2 }))
                                    }}
                                >Old Patient </li>
                            </ul>
                           {state.mainTab == 1&& <div id="tab-1" className={`appint-tab-content ${state.mainTab == 1 ? 'appint-tab-current' : ''}`}>
                                <div className="card">
                                    <div className="form">
                                        <div className="left-side">
                                            <div className="steps-content">
                                                <h3 style={{ display: "none" }}>
                                                    Step <span className="step-number">1</span>
                                                </h3>
                                                <div className="step-number-content active">
                                                    <h3>Personal Information</h3>
                                                    <p>Enter your personal information to get schedule time.</p>
                                                </div>
                                                <div className="step-number-content d-none ">
                                                    <h3>Scheduled</h3>
                                                    <p>Everything is going according to schedule.</p>
                                                </div>
                                                <div className="step-number-content d-none">
                                                    <h3>Payment</h3>
                                                    <p>
                                                        Help companies get to know you better by telling then about
                                                        your past experiences.
                                                    </p>
                                                </div>
                                            </div>
                                            <ProgressBar activeTab={state.activeTab}></ProgressBar>
                                        </div>
                                        <div className="right-side">
                                            <PersonalInformation
                                                activeTab={state.activeTab}
                                                data={state}
                                                handleChange={(e, Name) => { handleChange(e, Name) }}
                                                handleState={(name, value) => setState((prev) => ({ ...prev, [name]: value }))}
                                                handleSubmit={(data) => {
                                                    handleSubmit()
                                                }}
                                            ></PersonalInformation>
                                            <Shedule
                                                handleState={(name, value) => {
                                                    setState((prev) => ({ ...prev, [name]: value }))

                                                }}
                                                activeTab={state.activeTab}
                                                data={state}
                                                handlePrev={() => { setState((prev) => ({ ...prev, activeTab: 1 })) }}
                                                handleNext={() => { setState((prev) => ({ ...prev, activeTab: 3 })) }}
                                            ></Shedule>
                                            <Payment activeTab={state.activeTab} data={state}
                                                handlePrev={() => { setState((prev) => ({ ...prev, activeTab: 2 })) }}
                                                handleNext={() => { setState((prev) => ({ ...prev, activeTab: 4 })) }}></Payment>
                                            <PaymentSuccessful activeTab={state.activeTab} data={state} handleBack={() => { setState({FirstName: "", LastName: '', Description: '', Gender: 'Male', MobileNo: '', Email: '', Address: '', BirthDate: '', error: false, showDatePiker: false, day: '', time: "", activeTab: 1, isLoading: false, res: '', Endtime: '', razorpay_payment_id: '', userImage: '', ImageFile: '', paymentRes: "", appointmnetType: "new", fileId: '', Age: '', fileLoader: false, mainTab: 1,Options:{ show: false, value: '' },branchOption:{ show: false, value: Branch[0] }}) }}></PaymentSuccessful>
                                            {/* <paymnetscuu */}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                           <OldPatient mainTab={state.mainTab}></OldPatient>
                        </div>
                    </div>
                </div>
             
            </>

        </PageWrapper>
    );
}

export default MakeAppointmnet;